import { EProductCardForm } from '@/domain/product/EProductCardForm';

function canFold(cardForm: EProductCardForm | null): boolean {
    return cardForm === EProductCardForm.Folded;
}

export { canFold };
